"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityContentEmbed = exports.EntityContentEmbedDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_row_1 = require("./entity-row");
var cn_1 = require("../../utils/cn");
var cls = (0, cn_1.classNames)('entity-content-embed');
var react_medium_image_zoom_1 = __importDefault(require("react-medium-image-zoom"));
require("react-medium-image-zoom/dist/styles.css");
var lodash_1 = require("lodash");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var entity_menu_1 = require("./entity-menu");
var current_user_can_1 = require("../../utils/current-user-can");
var menu_context_1 = require("../context/menu-context");
exports.EntityContentEmbedDefaultProps = {
  imageSize: 68,
  showDescription: true
};
// -------- Styles -------->
var RowStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " ", " ", " ", ";\n    background: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    padding: ", " ", " ", " ", ";\n    background: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.COLOR('app-chrome'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ZoomStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: block;\n    margin: ", " 0;\n    position: relative;\n\n  "], ["\n    display: block;\n    margin: ", " 0;\n    position: relative;\n\n  "])), theme_1.theme.UNIT(3))
});
var ImgStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 100%;\n    margin: ", " 0;\n    display: block;\n    ", "\n  "], ["\n    width: 100%;\n    margin: ", " 0;\n    display: block;\n    ", "\n  "])), theme_1.theme.UNIT(3), function (props) {
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), props._maxWidth || 9999);
  })
});
var MenuStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    dsplay: none;\n    right: ", ";\n    position: absolute;\n    z-index: 50;\n    top: ", ";\n\n    .ellipsis-button {\n      background: ", ";\n      padding: 8px;\n      border-radius: 20px;\n    }\n  "], ["\n    dsplay: none;\n    right: ", ";\n    position: absolute;\n    z-index: 50;\n    top: ", ";\n\n    .ellipsis-button {\n      background: ", ";\n      padding: 8px;\n      border-radius: 20px;\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3 + 4), theme_1.theme.COLOR('app-chrome'))
});
var ImageContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
// -------- Components -------->
var My = {
  Row: (0, styled_components_1.default)(entity_row_1.EntityRow)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  Image: styled_components_1.default.img(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ImgStyles),
  Zoom: styled_components_1.default.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ZoomStyles),
  ImageContainer: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ImageContainerStyles),
  MenuContainer: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), MenuStyles),
  Menu: (0, styled_components_1.default)(entity_menu_1.EntityMenu)(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""])))
};
var EntityContentEmbed = function (props) {
  var className = props.className,
    entity = props.entity,
    rest = __rest(props, ["className", "entity"]);
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var imageUrl = (0, lodash_1.get)(entity, 'openGraph.image.url');
  var width = (0, lodash_1.get)(props, 'width');
  var nozoom = (0, lodash_1.get)(props, 'nozoom', false);
  if (defn && defn.valueImageStyle === 'banner' && imageUrl) {
    var image = react_1.default.createElement(My.Image, {
      _maxWidth: width,
      src: imageUrl
    });
    var menu = (0, current_user_can_1.currentUserCanUpdate)('ImageAsset') && react_1.default.createElement(menu_context_1.MenuProvider, {
      value: {
        preventDelete: true
      }
    }, react_1.default.createElement(My.MenuContainer, null, react_1.default.createElement(My.Menu, {
      entity: entity
    })));
    if (nozoom) {
      return react_1.default.createElement(My.ImageContainer, null, menu, image);
    }
    return react_1.default.createElement(My.ImageContainer, null, menu, react_1.default.createElement(My.Zoom, null, react_1.default.createElement(react_medium_image_zoom_1.default, {
      wrapElement: "span",
      zoomMargin: 20
    }, image)));
  }
  if (entity) {
    return react_1.default.createElement(My.Row, __assign({}, rest, {
      useLinks: true,
      entity: entity,
      className: cls.name(className)
    }));
  }
  return null;
};
exports.EntityContentEmbed = EntityContentEmbed;
exports.EntityContentEmbed.defaultProps = exports.EntityContentEmbedDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;